class TradeFormModal extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'modal', 'close']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.onTriggerClick.bind(this),
    )

    this.listeners.add(this.els.close.element, 'click', () =>
      this.closeTradeFormModal(),
    )

    this.listeners.add(this.els.closeBtn.element, 'click', () =>
      this.closeTradeFormModal(),
    )
  }

  onTriggerClick () {
    this.els?.modal?.element?.setAttribute('aria-hidden', 'false')
    document.body.classList.add('lyt-ModalOpen')
  }

  closeTradeFormModal () {
    this.els?.modal?.element?.setAttribute('aria-hidden', 'true')

    document.body.classList.remove('lyt-ModalOpen')
  }
}

if (!window.customElements.get('trade-form-modal')) {
  window.customElements.define('trade-form-modal', TradeFormModal)
}
